import {
  PAGE_CHANGE_PASSWORD,
  PAGE_COPILOT_MESSAGE,
  PAGE_EXPIRED_PASSWORD,
  PAGE_HOME,
  PAGE_LOGIN,
  PAGE_RESET_PASSWORD_CONFIRM,
} from "~/constants/page";
import CopilotMessage from "~/pages/copilotMessage/CopilotMessage";
import styles from "./AppRoute.module.less";
import { Route, Routes } from "react-router-dom";
import Login from "~/pages/login/Login";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import { PAGE_FORGOT_PASSWORD } from "../../../constants/page";
import ForgotPassword from "~/pages/forgotPassword/ForgotPassword";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import { LoginWrapper } from "~/pages/login/LoginWrapper";
import { ConfirmPasswordRecovery } from "~/pages/confirm-password-recovery/ConfirmPasswordRecovery";
import ExpiredPassword from "~/pages/expiredPassword/ExpiredPassword";
import ChangePassword from "~/pages/changePassword/ChangePassword";

function AppRoute() {
  const { token } = useAuthenticationContext();

  return (
    <div className={token ? styles.AppRoute : ""}>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path={PAGE_HOME} element={<CopilotMessage />} />
          <Route path={PAGE_COPILOT_MESSAGE} element={<CopilotMessage />} />
        </Route>

        <Route element={<PublicRoute />}>
          <Route path={PAGE_LOGIN} element={<Login />} />
          <Route path={PAGE_FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route
            path={PAGE_RESET_PASSWORD_CONFIRM}
            element={<ConfirmPasswordRecovery />}
          />
          <Route
            path={PAGE_CHANGE_PASSWORD}
            element={
              <LoginWrapper>
                <ChangePassword />
              </LoginWrapper>
            }
          />
          <Route path={PAGE_EXPIRED_PASSWORD} element={<ExpiredPassword />} />
        </Route>
      </Routes>
    </div>
  );
}

export default AppRoute;
